"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_1 = __importDefault(require("@emotion/styled"));
const react_virtualized_1 = require("@enykeev/react-virtualized");
const StyledList = (0, styled_1.default)(react_virtualized_1.List)({
    '&::-webkit-scrollbar': {
        width: 19
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundClip: 'padding-box',
        borderRadius: 10,
        borderWidth: 6,
        borderStyle: 'solid',
        minHeight: 70
    },
    '&::-webkit-scrollbar-track': {
        borderRadius: 6
    },
    '@-moz-document url-prefix()': {
        paddingRight: 18
    }
}, ({ theme }) => ({
    '&::-webkit-scrollbar-thumb': {
        borderColor: theme.palette.colors.lotion,
        backgroundColor: theme.palette.colors.columbiaBlue
    },
    '&::-webkit-scrollbar-track': {
        backgroundColor: theme.palette.colors.lotion
    }
}));
exports.default = StyledList;
//# sourceMappingURL=StyledList.js.map